
<header class="salePage">
  <div class="container">
    <div class="grid">
      <div class="cell l9">
        <h1>{{ context.config.display_name }}</h1>
      </div>
      <div class="cell l3">
        <div class="tbadge">
          <app-icon>verified_user</app-icon>
          <div>
            <a class="e--link-plain" [href]="context.links.promo_index|userToken" style="color:#3C4853" i18n>Verifiziert durch ELITEDOMAINS</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>

<div class="container salePage" [ngClass]="{'e--no-text': !context.config.template_data['individual-content--text']}">
  <div class="card">
    <div class="card-content">
      <div class="grid">
        <div
          [ngClass]="{'l6': context.config.template_data['individual-content--text']}"
          class="cell"
          >
          <p i18n>
            Die Domain <strong class="ed-domain-name">{{ context.config.display_name }}</strong> steht zum Verkauf. Bei
            Interesse können Sie diese Domain kaufen und den Inhaber der Domain über das Formular kontaktieren.
          </p>

          @if (context.config.price) {
            <hr>
              <p>
                <strong i18n>Preisvorstellung des Inhabers</strong><br>
                <app-price [amount]="context.config.price"/>
                <app-tax-note [type]="context.user.paynow.price_type"/>
              </p>
            }

            @if (context.user.paynow.public_phone) {
              <hr>
                <p>
                  <strong i18n>Telefonnummer des Inhabers</strong><br>
                  <ng-container>{{ context.user.paynow.public_phone }}</ng-container>
                </p>
              }

              <hr>

                <app-contactform [context]="context"/>
              </div>

              @if (context.config.template_data['individual-content--text']) {
                <div class="cell l6">
                  <app-content-block
                    [content]="{
                      headline: context.config.template_data['individual-content--headline'],
                      text: context.config.template_data['individual-content--text'],
                    }"
                  />
                </div>
              }
            </div>
          </div>
        </div>
      </div>

      <footer class="salePage">
        <div class="container">
          <app-i18n-selector/>

          <p i18n class="ed-footer-paragraph">
            Die Domain {{ context.config.display_name }} wird auf diesem
            <a [href]="context.links.marketplace|userToken|safe" target="_blank">Domain Marktplatz</a>
            angeboten. Über dieses Formular kann entweder ein Angebot zum Kauf der Domain abgeben oder der
            Verantwortliche direkt kontaktiert werden. Alle Anfragen werden durch die kostenlose Technologie zum
            <a [href]="context.links.promo_sell_domains|userToken|safe" target="_blank">Domains verkaufen</a>
            automatisiert an den Inhaber weitergeleitet.
          </p>
          <ul class="list-inline">
            <li><a [href]="context.links.promo_index|userToken" target="_blank" i18n>ELITEDOMAINS</a></li>
            <li><a [href]="context.links.privacy|userToken" target="_blank" i18n>Datenschutz</a></li>
            <li><a [routerLink]="['/impressum']" rel="nofollow" target="_blank" i18n>Impressum</a></li>
          </ul>
        </div>
      </footer>
